import { Component, computed, inject, input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxButtonComponent,
  OnyxDividerComponent,
  OnyxInformationHeadingComponent,
  OnyxToastService,
} from '@onyx/angular';
import type { Subject } from 'rxjs';
import { OrderStatus } from '../../../../common/enums/order-status';
import { OrderHelper } from '../../../../common/helpers/order.helper';
import type { Order } from '../../../../common/interfaces/order';
import { OrdersService } from '../../../../common/services/orders.service';
import { OrderModalDocumentsComponent } from '../../order-modal-documents/order-modal-documents.component';
import { OrderModalInvoiceFormComponent } from './order-modal-invoice-form/order-modal-invoice-form.component';
import { OrderModalPaymentFormContainerComponent } from './order-modal-payment-form-container/order-modal-payment-form-container.component';
import { OrderModalPaymentsHistoryComponent } from './order-modal-payments-history/order-modal-payments-history.component';

@Component({
  selector: 'app-order-modal-finished-section',
  imports: [
    OnyxButtonComponent,
    TranslatePipe,
    OrderModalDocumentsComponent,
    OnyxButtonComponent,
    OrderModalInvoiceFormComponent,
    OrderModalPaymentsHistoryComponent,
    OrderModalPaymentFormContainerComponent,
    OnyxInformationHeadingComponent,
    OnyxDividerComponent,
  ],
  templateUrl: './order-modal-finished-section.component.html',
  styleUrl: './order-modal-finished-section.component.scss',
})
export class OrderModalFinishedSectionComponent {
  private readonly toastService = inject(OnyxToastService);
  private readonly ordersService = inject(OrdersService);

  public readonly order = input.required<Order>();
  public readonly close$ = input.required<Subject<void>>();

  protected readonly I18N = 'orders.orderModal';

  protected readonly OrderStatus = OrderStatus;

  protected loading = signal(false);
  protected showInvoiceForm = signal(false);

  protected hasRequiredDocuments = computed(() =>
    OrderHelper.hasRequiredDocuments(
      this.order().payment.contractorInvoiceDocuments.shippingType,
    ),
  );

  protected isWaitingForCollectiveInvoiceIssue = computed(() =>
    OrderHelper.isWaitingForCollectiveInvoiceIssue(
      this.order().payment.collectiveInvoiceIssueFrom,
    ),
  );

  protected completeDocuments(): void {
    this.loading.set(true);
    this.ordersService
      .completeDocuments(this.order().uuid)
      .subscribe(() =>
        this.toastService.showSuccess({
          message: `${this.I18N}.toasts.documentsCompleted`,
          keepOnNavigation: true,
        }),
      )
      .add(() => this.loading.set(false));
  }

  protected toggleInvoiceForm(): void {
    this.showInvoiceForm.update((show) => !show);
  }
}
